<template>
  <div>
    <van-nav-bar
      title="忘记密码"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/login')"
    />
    <div class="wrap">
      <div class="logo">
        <img
          :src="$store.state.login_logo_url"
          style="width: 100%"
          v-if="$store.state.login_logo_url"
        />
        <img
          :src="require('../assets/images/logo.png')"
          style="width: 100%"
          v-if="!$store.state.login_logo_url"
        />
      </div>
      <van-form @submit="onForget">
        <van-field
          v-model="phone"
          type="tel"
          name="phone"
          label="手机号"
          placeholder="请输入手机号"
          autocomplete="off"
        />
        <van-field
          v-model="rePicCode"
          center
          clearable
          label="验证码"
          placeholder="请输入验证码"
        >
          <div slot="button">
            <img
              :src="captcha"
              @click="this.getCaptcha"
              style="height: 25px; width: 80px"
            />
          </div>
        </van-field>
        <van-field
          v-model="sms"
          type="digit"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          autocomplete="off"
        >
          <template #button>
            <van-button
              size="small"
              plain
              type="info"
              native-type="button"
              :disabled="disabled"
              @click="getRealName"
              >{{ getCodeText }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="新密码"
          placeholder="请输入新密码"
          autocomplete="off"
        />
        <van-field
          v-model="verify"
          type="password"
          name="password"
          label="再次新密码"
          placeholder="在次输入新密码"
          autocomplete="off"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            size="small"
            native-type="submit"
          >
            完成
          </van-button>
        </div>
      </van-form>
    </div>
    <van-dialog v-model="showModal" show-cancel-button :beforeClose="getPhoneCode">
      <van-cell-group>
        <van-field type="text" v-model="realName" label="姓名：" placeholder="请输入您的真实姓名" />
   
        <van-field type="text" v-model="card" label="身份证号码：" placeholder="请输入您的卡" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Forget",
  data() {
    return {
      phone: "",
      sms: "",
      password: "",
      verify: "",
      disabled: false,
      getCodeText: "获取验证码",
      rePicCode: "",
      captcha: "",
      verify_token: "",
      showModal:false,
      realName:'',
      card:''
    };
  },
  methods: {
    getRealName(){
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail("手机号格式不正确");
      } else {
        that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "realname_verification",
          phone: that.phone
        },
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.showModal=true;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(res.data.msg);
            
          }
        });
    
      }
    },
    getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha = resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onForget() {
      let that = this;
      if (that.password !== that.verify) {
        that.$toast.fail("两次密码不相同,请重新输入");
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail("手机号格式不正确");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let forgetPhone = that.encryptMessage(userPhone, publicKey);
        let forgetPassword = that.encryptMessage(that.password, publicKey);
        let forgetPwConfirm = that.encryptMessage(that.verify, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "forgot_password_e",
              phone: forgetPhone,
              code: that.sms,
              password: forgetPassword,
              confirm: forgetPwConfirm,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast({
                message: res.data.msg,
                type: "success",
                onClose: function () {
                  that.$router.push({
                    path: "/login",
                  });
                },
              });
            } else if (res.data.code == 0) {
              that.$toast.fail(res.data.msg);
            }
          });
      }
    },
    getPhoneCode(action,done) {
      let that = this;
      switch(action){
        case 'confirm':
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$toast.fail("手机号格式不正确");
        done();
      } else {
        
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let phoneNumber = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "forgot_code_e",
              phone: phoneNumber,
              rePicCode: that.rePicCode,
              verify_token: that.verify_token,
              realname:that.realName,
              card:that.card
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast({
                message: res.data.msg,
                type: "success",
              });
              var time = 60;
              that.getCodeText = time + "s";
              that.disabled = true;
              var timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  that.getCodeText = "获取验证码";
                  that.disabled = false;
                  clearInterval(timer1);
                }
              }, 1000);
              done();
            } else if (res.data.code == 0) {
              that.realName='';
              that.card='';
              done();
              that.$toast.fail(res.data.msg);
            }
          });
          
      }
      break;
          case 'cancel':
            done();
            break;
    }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    // isLogin() {
    //   let that = this;
    //   if (that.$store.state.loginType) {
    //     this.$router.push("/member");
    //   }
    // },
  },
  mounted: function () {
    this.getCaptcha();
    // this.isLogin();
  },
};
</script>

<style scoped>
.wrap {
  width: 90%;
  margin: 0 auto;
}
.logo {
  width: 50%;
  margin: 100px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Forget.vue